<template>
    <div class="page-section max-width-600-tablet-desktop">
        <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-width="140px"
            @submit.prevent="passwordChange"
        >
            <el-form-item
                label="New password"
                prop="password"
                :error="formErrors.get('password')"
            >
                <el-input
                    v-model="form.password"
                    type="password"
                    show-password
                />
            </el-form-item>
            <el-form-item
                label="Confirm Password"
                prop="password_confirmation"
                :error="formErrors.get('password_confirmation')"
            >
                <el-input
                    v-model="form.password_confirmation"
                    type="password"
                    show-password
                />
            </el-form-item>
        </el-form>
        <div>
            <el-button
                @click="cancel"
            >
                Cancel
            </el-button>
            <el-button
                type="success"
                @click.prevent="passwordChange"
            >
                Save Password
            </el-button>
        </div>
    </div>
</template>

<script setup>
import {ref} from 'vue'
import axios from 'axios'
import {useRoute, useRouter} from 'vue-router'
import {ElMessage} from 'element-plus'
import {Errors} from '~/includes/Errors'
import profileApi from '~/modules/profile/profileApi'

const router = useRouter()
const route = useRoute()
const emit = defineEmits()

const formRef = ref()

const form = ref({
    password_confirmation: '',
    password: '',
})

const rules = {
    password: [{ required: true, trigger: 'change' }],
    password_confirmation: [{ required: true, validator: checkPassIdentical, trigger: 'blur' },],
}

const formErrors = new Errors()

function passwordChange() {
    formErrors.record([])
    profileApi.changePassword(form.value).then(response => {
        ElMessage.success('Password changed successfully!')
        emit('saved')
        clearForm()
    }).catch(error => {
        if (error.response.data.errors) {
            formErrors.record(error.response.data.errors)
        }
    })
}

function checkPassIdentical(rule, value, callback) {
    if (!value) {
        return callback(new Error(
            'Password confirmation is required'
        ))
    }

    if (value !== form.value.password) {
        callback(new Error('Mismatch password'))
    } else {
        callback()
    }
}

function cancel() {
    clearForm()
    emit('cancel')
}

function clearForm() {
    formErrors.clear()
    if (formRef.value) formRef.value.resetFields()
}

</script>
